import React from 'react';
const rows = [['An evening a week building the next session', 'Open the Run Sheet, read for 20 minutes'], ['Guessing what should come after what', '57 sessions in order, across a full year'], ['Hunting for stats in the middle of the game', 'Creature Quick Cards, grouped by session'], ['Ending on a closed door', 'A cliffhanger built to bring players back'], ['The same three one-shots on repeat', 'Six stages of a table, from first seat to next season']];
export function CostOfInaction() {
  return <section className="w-full bg-plum-deep" data-id="element-58" data-mp="38wk18usknycy">
      <div className="max-w-3xl mx-auto px-5 py-16 sm:py-20" data-id="element-59" data-mp="38v8xuw31gsmd">
        <h2 className="text-center font-display font-semibold text-white text-3xl sm:text-4xl" data-id="element-60" data-mp="3dpmybcwk5pxw">
          What another year of prepping from scratch{' '}
          <span className="text-gold" data-id="element-61" data-mp="3nmrlng253rga">costs you</span>
        </h2>

        <div className="mt-8 overflow-hidden rounded-3xl border border-plum-line" data-id="element-62" data-mp="3nketyb6ky2q1">
          <div className="grid grid-cols-2 bg-plum-mid text-center text-[10px] font-semibold uppercase tracking-widest" data-id="element-63" data-mp="3sm49a30u52jx">
            <div className="border-r border-plum-line px-3 py-2.5 text-coral-soft" data-id="element-64" data-mp="3ee3jl6vpoa5f">
              Without the Loop
            </div>
            <div className="px-3 py-2.5 text-gold" data-id="element-65" data-mp="34hqs8fnn28du">With Paid Table Ready</div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-plum-line text-[12.5px] sm:text-sm" data-id="element-66" data-mp="30i9kffkqoz5i">
              <div className="border-r border-plum-line px-3.5 py-3.5 text-white/60 line-through decoration-coral/60" data-id="element-67" data-mp="3s84lg9hymda0">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-medium text-white" data-id="element-68" data-mp="3nfbi9q253d01">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}